import { Row } from "react-bootstrap";
import { useState, useRef, useEffect } from 'react';
import { /* Button, */ Input, /* Space, */ Table, Form, InputNumber, Empty } from 'antd';
// import { SearchOutlined } from '@ant-design/icons';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import Highlighter from 'react-highlight-words';
import { useSelector, useDispatch } from 'react-redux'
import {
    /* setFile, */ getStyle, getObjective, getServices
} from '../../../../libs/todoSlice'
//function edit table
const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};
// end edit table
export default function AddProviderIDPreRegisterSuccess  ({ memberOneSuccess, memberCASuccess })  {
    const dispatch = useDispatch()
    const style = useSelector(getStyle)
    const objective = useSelector(getObjective)
    const services = useSelector(getServices)
    // function show member to success table
    useEffect(() => {
        

        setData(memberOneSuccess.map((members, index) => {
            const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
            const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
            const accountTitleENG = title_en_list[title_th_list.indexOf(members.request.account_title_th)]
            return {
                index: index + 1,
                address: members.request.address,
                sub_district: members.request.sub_district,
                district: members.request.district,
                province: members.request.province,
                zipcode: members.request.zipcode,
                idCardType: members.request.id_card_type,
                idCardNum: members.request.id_card_num,
                mobileNO: members.request.mobile_no,
                employeeID: members.request.employee_id,
                name_th: (members.request.account_title_th ? members.request.account_title_th : members.request.account_title_th ? members.request.account_title_th : '') + " " +
                    (members.request.first_name_th ? members.request.first_name_th : '') + " " +
                    (members.request.middle_name_th ? members.request.middle_name_th : '') + " " +
                    (members.request.last_name_th ? members.request.last_name_th : ''),
                name_eng: (members.request.specialTitleENG ? members.request.account_title_eng : accountTitleENG ? members.request.account_title_eng : '') + " " +
                    (members.request.first_name_eng ? members.request.first_name_eng : '') + " " +
                    (members.request.middle_name_eng ? members.request.middle_name_eng : '') + " " +
                    (members.request.last_name_eng ? members.request.last_name_eng : ''),
            }
        }))
    }, [memberOneSuccess])
    // end function show member to success table
    //function edit table
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.index === editingKey;

    const cancel = () => {
        setEditingKey('');
    };


    // function search
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const customLocale = {
        emptyText: (<Empty
            description="ไม่มีข้อมูล"
        />)
    };


    const mergedColumns = [
        {
            title: 'ลำดับ',
            width: 70,
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (
                <div>
                    ชื่อ - นามสกุล <br />(ภาษาไทย)
                </div>
            ),
            dataIndex: 'name_th',
            key: 'name_th',
            show: true,
            width: 150,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (
                <div>
                    ชื่อ - นามสกุล <br />(ภาษาอังกฤษ)
                </div>
            ),
            dataIndex: 'name_eng',
            key: 'name_eng',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'ประเภทบัตร',
            dataIndex: 'idCardType',
            key: 'idCardType',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'เลขบัตรประชาชน',
            dataIndex: 'idCardNum',
            key: 'idCardNum',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'รหัสพนักงาน',
            dataIndex: 'employeeID',
            key: 'employeeID',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],

        },
        {
            title: 'เบอร์โทร',
            dataIndex: 'mobileNO',
            key: 'mobileNO',
            show: true,
            width: 150,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],

        },
        {
            title: 'ที่อยู่',
            dataIndex: 'address',
            key: 'address',
            show: true,
            width: 250,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },

        {
            title: 'ตำบล',
            dataIndex: 'sub_district',
            key: 'sub_district',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'อำเภอ',
            dataIndex: 'district',
            key: 'district',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'จังหวัด',
            dataIndex: 'province',
            key: 'province',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'รหัสไปรษณีย์',
            dataIndex: 'zipcode',
            key: 'zipcode',
            show: true,
            width: 160,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
    ].filter(head => !head.hidden && head.show).map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'age' ||
                    col.dataIndex === 'index' ||
                    col.dataIndex === 'no' ? 'number' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    // end edit table
    return (
        <>
            {/* <Row style={{marginBottom:'20px'}}>
            <Col className="d-flex justify-content-end">
              <Button size="large" > <RefreshIcon/> Resend Mail </Button>
            </Col>
          </Row> */}
            <Row>
                {/* ui table */}
                <Form form={form} component={false}>
                    <Table
                        locale={customLocale}
                        components={{
                            body: {
                                cell: EditableCell,
                            },
                        }}
                        bordered
                        dataSource={data}
                        columns={mergedColumns}
                        rowClassName="editable-row"
                        pagination={{
                            onChange: cancel,
                        }}
                        scroll={{
                            x: 1400,
                            y: 400,
                        }}

                    />
                </Form>
                {/* end ui table */}
            </Row>
        </>
    )

}
